import { defineStore } from 'pinia'
import type { Userdetail } from './types'

export const useCommonStore = defineStore({
  id: 'common',
  state: () => ({
    userDetails: {
      email: '',
      firstname: '',
      lastname: '',
      role: '',
      ucc: ''
    }
  }),
  getters: {
    getUserDetails(state): Userdetail {
      return state.userDetails
    }
  },
  actions: {
    fetchUserDetails(payload: Userdetail) {
      this.userDetails = {
        firstname: payload?.['firstname'],
        lastname: payload?.['lastname'],
        email: payload?.['email'],
        role: payload?.['role'],
        ucc: payload?.['ucc']
      }
    }
  }
})
